import React from 'react';
import AssetLinkCell from '@nile/rmm/src/modules/asset-management/components/sub-pages/asset-link-cell';
import { set } from 'lodash';

export const AssetsCell = (props) => {
  const { cell } = props;
  const constructedProps = set(
    { ...props },
    'cell.row.original',
    cell?.row?.original?.asset
  ); // changing structure to fit to existing component

  return <AssetLinkCell {...constructedProps} />;
};
